import React from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  return (
    <nav className="navbar">
      <ul>
        <li>
          <NavLink to="/" activeClassName="active">
            Create Hash
          </NavLink>
        </li>
        {/* <li>
          <NavLink to="/sign-hash" activeClassName="active">
            Sign Hash
          </NavLink>
        </li> */}
        <li>
          <NavLink to="/recover-tx" activeClassName="active">
            Recover Tx
          </NavLink>
        </li>
        <li>
          <NavLink to="/finalize-tx" activeClassName="active">
            Finalize Tx
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
